import React from 'react';
import {
  VehicleDetailsWrapper,
  Image,
  CarInfo,
  Make,
  Model,
  PurchaseInfo,
  Date,
  OverviewHeading,
  OverviewVinNumber,
} from './VehicleDetails.styles';
import { formatDate } from '../../../utils/dateUtils';

const VehicleDetails = ({ myCar, isOverviewCard }: any) => {
  const { image, year, make, model, trim, saleDate, vin } = myCar;

  return (
    <>
      {isOverviewCard && <OverviewHeading>Overview</OverviewHeading>}
      <VehicleDetailsWrapper>
        <Image src={image} alt={`${make} ${model} - ${trim}`} />
        <CarInfo>
          <Make
            isOverviewCard={isOverviewCard}
          >{`${year} ${make} ${model}`}</Make>
          <Model>{trim}</Model>
          <OverviewVinNumber>VIN: {vin}</OverviewVinNumber>
          <PurchaseInfo isOverviewCard={isOverviewCard}>
            Purchased on <Date>{formatDate(saleDate)}</Date>
          </PurchaseInfo>
        </CarInfo>
      </VehicleDetailsWrapper>
    </>
  );
};

export default VehicleDetails;
